import './bootstrap';
import '../css/app.scss';
import "vue-toastification/dist/index.css";

import { createApp, h, DefineComponent } from 'vue';
import { ZiggyVue } from "ziggy-js";

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { plugin as inertiaPlugin } from "formkit-addon-inertia";

import { plugin as FKp, defaultConfig as FKdc } from '@formkit/vue'
import Toast from "vue-toastification";

import { WagmiPlugin } from '@wagmi/vue'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { wagmiAdapter } from '../js/Pages/Gpt/Components/chatComposables/WalletConnectConfig/walletConfig';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { 
    faBolt,
    faFlask,
    faMicrochip,
    faCircleNodes,
    faUser,
    faCodePullRequest,
    faWallet,
    faMap
} from '@fortawesome/free-solid-svg-icons'
import { 
    faBitcoin,
    faEthereum
} from '@fortawesome/free-brands-svg-icons'

import { ENV } from './utils/useConfig';

const envconfig = ENV;

/* add icons to the library */
library.add(faBolt, faFlask, faMicrochip, faCircleNodes, faUser, faCodePullRequest, faWallet, faBitcoin, faEthereum, faMap)

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
const queryClient = new QueryClient();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob<DefineComponent>('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });
        app.provide('envconfig', envconfig);
        app
            .use(plugin)
            .use(FKp, FKdc({ plugins: [inertiaPlugin] }))
            .use(ZiggyVue, Ziggy)
            .use(Toast)
            .component('font-awesome-icon', FontAwesomeIcon)
            .use(WagmiPlugin, { config: wagmiAdapter.wagmiConfig })
            .use(VueQueryPlugin, { queryClient })
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

